module.exports = __webpack_public_path__ + "static/media/rumi-logo-pwa@3x.6a6b71a4.jpg";